export default __webpack_public_path__ + "static/media/device-guide-hero.98bded3f.png";